/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_HofInputs */

const en_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame`)
};

const es_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salón de la fama`)
};

const de_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruhmeshalle`)
};

const zh_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名人堂`)
};

const ar_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قاعة المشاهير`)
};

const fr_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temple de la renommée`)
};

const vi_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đại sảnh danh vọng`)
};

const sw_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukumbi wa Umaarufu`)
};

const th_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หอเกียรติยศ`)
};

const bs_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuća slavnih`)
};

const ja_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`殿堂`)
};

const ko_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`명예의 전당`)
};

const pt_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall da Fama`)
};

const it_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame`)
};

const sv_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ärans hall`)
};

const nl_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eregalerij`)
};

const da_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Æresgalleri`)
};

const nb_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Æresgalleri`)
};

const fi_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunniagalleria`)
};

const pl_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeria sław`)
};

const ru_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зал славы`)
};

const tr_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şöhretler Müzesi`)
};

const hi_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हॉल ऑफ फेम`)
};

const id_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balai Kehormatan`)
};

const ms_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dewan Kemasyhuran`)
};

const cs_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Síň slávy`)
};

const el_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πάνθεον Διασήμων`)
};

const he_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היכל התהילה`)
};

const af_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eregalery`)
};

const hu_footer_link_hof = /** @type {(inputs: Footer_Link_HofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hírességek Csarnoka`)
};

/**
* | output |
* | --- |
* | "Hall of Fame" |
*
* @param {Footer_Link_HofInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_link_hof = /** @type {((inputs?: Footer_Link_HofInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_HofInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_link_hof(inputs)
	if (locale === "de") return de_footer_link_hof(inputs)
	if (locale === "zh") return zh_footer_link_hof(inputs)
	if (locale === "ar") return ar_footer_link_hof(inputs)
	if (locale === "fr") return fr_footer_link_hof(inputs)
	if (locale === "vi") return vi_footer_link_hof(inputs)
	if (locale === "sw") return sw_footer_link_hof(inputs)
	if (locale === "th") return th_footer_link_hof(inputs)
	if (locale === "bs") return bs_footer_link_hof(inputs)
	if (locale === "ja") return ja_footer_link_hof(inputs)
	if (locale === "ko") return ko_footer_link_hof(inputs)
	if (locale === "pt") return pt_footer_link_hof(inputs)
	if (locale === "it") return it_footer_link_hof(inputs)
	if (locale === "sv") return sv_footer_link_hof(inputs)
	if (locale === "nl") return nl_footer_link_hof(inputs)
	if (locale === "da") return da_footer_link_hof(inputs)
	if (locale === "nb") return nb_footer_link_hof(inputs)
	if (locale === "fi") return fi_footer_link_hof(inputs)
	if (locale === "pl") return pl_footer_link_hof(inputs)
	if (locale === "ru") return ru_footer_link_hof(inputs)
	if (locale === "tr") return tr_footer_link_hof(inputs)
	if (locale === "hi") return hi_footer_link_hof(inputs)
	if (locale === "id") return id_footer_link_hof(inputs)
	if (locale === "ms") return ms_footer_link_hof(inputs)
	if (locale === "cs") return cs_footer_link_hof(inputs)
	if (locale === "el") return el_footer_link_hof(inputs)
	if (locale === "he") return he_footer_link_hof(inputs)
	if (locale === "af") return af_footer_link_hof(inputs)
	if (locale === "hu") return hu_footer_link_hof(inputs)
	return en_footer_link_hof(inputs)
});